import { combineReducers } from "redux";
import activeModeleReducer from "./active-modele-reducer";
import selectedPositionReducer from "./selected-position-reducer";
import selectedModeleReducer from "./selected-modele-reducer";
import selectedColorReducer from "./selected-color-reducer";
import coloredSquaresReducer from "./colored-squares-reducer";
import imageDataReducer from "./image-data-reducer";
import canvasReducer from "./canvas-reducer";
import comparisonReducer from "./comparison-reducer";

const rootReducer = combineReducers({
    activeModele: activeModeleReducer,
    selectedPosition: selectedPositionReducer,
    selectedModele: selectedModeleReducer,
    selectedColor: selectedColorReducer,
    coloredSquares: coloredSquaresReducer,
    imageData: imageDataReducer,
    canvas: canvasReducer,
    comparison: comparisonReducer,
});
export default rootReducer;
